import { render, staticRenderFns } from "./goodsAddition.vue?vue&type=template&id=600ce184&scoped=true&"
import script from "./goodsAddition.vue?vue&type=script&lang=ts&"
export * from "./goodsAddition.vue?vue&type=script&lang=ts&"
import style0 from "./goodsAddition.vue?vue&type=style&index=0&id=600ce184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ce184",
  null
  
)

export default component.exports